import React, { useState, useEffect } from 'react';
import { Modal, Button, InputGroup, FormControl, Tooltip, OverlayTrigger, Form } from 'react-bootstrap';
import { FaClipboard, FaUser, FaEnvelope, FaTelegramPlane, FaWhatsapp } from 'react-icons/fa';
import Select from 'react-select'; // Assuming you use react-select
// import { Typeahead } from 'react-bootstrap-typeahead'; // Or another typeahead library
import { InternalSharedReportsGet, InternalSharedReportSaveforShareReport, sendDocumenttoEmail, getQRCode, getValidityOptions } from 'apiServices';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { CustomSuccessModal, LoadingSpinner } from 'components';
import { showNotificationIfAllowed } from '../../utils/pushNotification';
import './shareReportDialog.css';

// Placeholder for API calls - replace with your actual service calls/Redux actions


function ShareReportModal({
    show,
    onHide,
    reportName,
    reportId,
    reportLink, // Assuming a base link is passed or constructed
    onShareReport,
    token,
    userID// Function prop to handle the actual sharing API call: onShareReport(method, data)
}) {

    const [shareMethod, setShareMethod] = useState(null); // 'pmr', 'email', 'sms', 'whatsapp', null
    const [emailAddress, setEmailAddress] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [internalUser, setInternalUser] = useState(null); // For react-select Acme Health user
    const [notes, setNotes] = useState('');
    const [validity, setValidity] = useState(null); // For react-select validity
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [isLoadingQr, setIsLoadingQr] = useState(false);
    const [internalUsersOptions, setInternalUsersOptions] = useState([]);
    const [validityOptions, setValidityOptions] = useState([]);
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);
    const [submitClicked, setSubmitClicked] = useState(false); // For validation styling if needed
    const [searchInput, setSearchInput] = useState(''); // Track search 
    const [copyLink, setCopyLink] = useState('');
    const dispatch = useDispatch();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showComingSoonModal, setShowComingSoonModal] = useState(false);
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const params = {
        token: token,
        userID: userID,
        SearchKey: internalUser,

    }
    const customStyles = {
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            minWidth: '400px',
            minHeight: '28px',
            backgroundColor: 'var(--pmr-white)',
            border: '1px solid var(--pmr-border)',
            borderRadius: '8px',
            overflow: 'hidden',
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        control: (provided, state) => ({
            ...provided,
            minHeight: '38px',
            minWidth: '400px',
            borderRadius: '8px',
            boxShadow: state.isFocused ? '0 0 0 0.15rem var(--pmr-primary-focus-ring)' : 'none',
            borderColor: state.selectProps.isInvalid
                ? 'var(--pmr-danger)'
                : state.isFocused
                    ? 'var(--pmr-primary)'
                    : 'var(--pmr-border-input)',
            '&:hover': {
                borderColor: state.selectProps.isInvalid
                    ? 'var(--pmr-danger)'
                    : state.isFocused
                        ? 'var(--pmr-primary)'
                        : 'var(--pmr-border-input)',
            },
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? 'var(--pmr-primary)'
                : state.isFocused
                    ? 'var(--pmr-primary-light)'
                    : 'var(--pmr-white)',
            color: state.isSelected ? 'var(--pmr-white)' : 'var(--pmr-text)',
            cursor: 'pointer',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: 'var(--pmr-text)',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: 'var(--pmr-text-muted)',
        }),
    };


    const fetchInternalUsers = async (searchTerm = '') => {
        setIsLoadingUsers(true);
        const searchParams = {
            token: token,
            LoginUserID: userID,
            SearchKey: searchTerm,
        };

        console.log("Fetching internal users with params:", searchParams);

        try {
            const res = await dispatch(InternalSharedReportsGet(searchParams));
            console.log("Full API Response:", res);
            // Map using user_name and email_address
            const transformedData = (res.payload.Table || []).map((user) => ({
                value: user.email_address,
                label: user.user_name,
                user_id: user.user_id
            }));
            console.log("Transformed data:", transformedData);
            setInternalUsersOptions(transformedData);
            return transformedData;
        } catch (err) {
            console.error("Failed to fetch internal users:", err);
            setInternalUsersOptions([]);
            return [];
        } finally {
            setIsLoadingUsers(false);
        }
    };
    const saveInternalSharedReport = async (formBody) => {
        dispatch(InternalSharedReportSaveforShareReport(formBody));

    }

    // Fetch QR Code when modal opens or reportId changes
    useEffect(() => {

        if (show && reportId) {
            getQRCodeData();

        } else {
            setQrCodeUrl(''); // Clear QR when hidden
        }
    }, [show, reportId]);

    // Fetch validity options
    useEffect(() => {
        if (show) {
            const params = {
                user_id: userID,
                token: token
            }
            dispatch(getValidityOptions(params)).then((res) => {
                console.log("Validity options res", res);
                if (res.payload && res.payload.Table) {
                    // Transform the API response to react-select format
                    const transformedOptions = res.payload.Table.map((option) => ({
                        value: option.validity_id || option.id || option.value,
                        label: option.validity_name || option.name || option.label
                    }));
                    console.log("Transformed validity options:", transformedOptions);
                    setValidityOptions(transformedOptions);
                } else {
                    console.error("Invalid validity options response:", res);
                    setValidityOptions([]);
                }
            }).catch((err) => {
                console.error("Error fetching validity options:", err);
                setValidityOptions([]);
            });
        }
    }, [show]);

    // Clear internal user options when Acme Health method is selected (search runs after 3+ chars typed)
    useEffect(() => {
        if (shareMethod === 'pmr') {
            setInternalUsersOptions([]);
        }
    }, [shareMethod]);

    // Clear search input when share method changes
    useEffect(() => {
        setSearchInput('');
        setInternalUser(null);
    }, [shareMethod]);

    // Debug useEffect to monitor internalUsersOptions changes
    useEffect(() => {
        console.log("internalUsersOptions changed:", internalUsersOptions);
    }, [internalUsersOptions]);

    // Debug useEffect to monitor validityOptions changes
    useEffect(() => {
        console.log("validityOptions changed:", validityOptions);
    }, [validityOptions]);

    // --- Input Handlers ---
    const handleMethodSelect = (method) => {
        setShareMethod(method);
        // Clear other fields when method changes
        setEmailAddress('');
        setPhoneNumber('');
        setNotes('');
        setValidity(null);
        setSubmitClicked(false); // Reset validation display
    };

    // --- Action Handlers ---
    const handleCopyLink = () => {
        console.log("copyLink", copyLink);
        if (copyLink !== '') {
            navigator.clipboard.writeText(copyLink)
                .then(() => {
                    console.log('Link copied!');
                    setMessage("Link copied successfully");
                    setShowSuccessModal(true);

                })
                .catch(err => {
                    console.error('Failed to copy link: ', err);
                });
        } else {
            setMessage("No link to copy!");
        }
    };
    const getQRCodeData = async () => {
        const QRparams = {
            UserID: userID,
            ReportID: reportId,
            token: token
        };
        dispatch(getQRCode(QRparams)).then((res) => {
            console.log("QR Code res", res);
            setIsLoadingQr(true);

            // Defensive check
            if (res.payload !== null && res.payload.base64String) {
                const URL = res.payload.URL;
                const base64String = res.payload.base64String;

                // Validate base64String is not empty
                if (base64String && base64String.trim() !== '') {
                    setQrCodeUrl(`data:image/png;base64,${base64String}`);
                    setCopyLink(URL);
                    console.log("URL", URL);
                    console.log("base64String length:", base64String.length);
                } else {
                    console.error("base64String is empty or invalid");
                    setQrCodeUrl('');
                }
            } else {
                setQrCodeUrl('');
                console.error("QR code data missing in response", res);
            }
            setIsLoadingQr(false);
        }).catch((err) => {
            setQrCodeUrl('');
            setIsLoadingQr(false);
            console.error("Error fetching QR code", err);
        });
    };

    const handleShare = () => {
        setSubmitClicked(true);

        let isValid = false;
        console.log("internalUser", internalUser);

        if (shareMethod === 'pmr' && internalUser !== null && validity) {
            setIsLoading(true);

            const shareData = {
                LoginUserID: userID,
                ReportID: reportId,
                UserID: internalUser.user_id,
                ValidityID: validity.value,
                Notes: notes,
                SharedToName: internalUser.label,
                ShareNotes: notes,
                RelationTypeID: 1,
                SharedToEmail: internalUser.value,
                token: token
            }
            dispatch(InternalSharedReportSaveforShareReport(shareData)).then((res) => {
                console.log("res", res);
                setIsLoading(false);
                const data = res.payload?.data ?? res.payload;
                if (res.payload?.status === 200 && data) {
                    const pushStatus = data.push_status ?? data.Push_status ?? "not returned by API";
                    console.log("report share push_status", pushStatus, data);
                    setShowSuccessModal(true);
                    setMessage("Report shared successfully. Push: " + pushStatus);
                    const sharedToId = data.shared_to_id ?? data.SharedToId;
                    const title = data.title ?? data.Title;
                    const pushMessage = data.message ?? data.Message;
                    if (title && pushMessage && Number(sharedToId) === Number(userID)) {
                        showNotificationIfAllowed({
                            userId: userID,
                            token,
                            title,
                            body: pushMessage,
                            url: data.url ?? data.Url ?? window.location.href,
                            tag: `pmr-share-${Date.now()}`,
                        }).catch(() => {});
                    }
                } else {

                }
            }).catch(() => {
                setIsLoading(false);
            });
        } else if (shareMethod === 'email') {
            // Set loading to true before API call
            setIsLoading(true);

            const emailData = {
                LoginUserID: userID,
                report_id: reportId,
                user_id: userID,
                email_address: emailAddress,
                token: token,
                mode: 'Mail',
                site_id: null,
            }
            dispatch(sendDocumenttoEmail(emailData)).then((res) => {
                console.log("res", res);
                setIsLoading(false); // Hide loading
                if (res.payload.data) {
                    setShowSuccessModal(true);
                    setMessage("Report shared successfully");
                } else {

                }
            });

        }
    };

    // --- Typeahead/Async Select Logic ---
    const loadInternalUsers = (inputValue, callback) => {
        fetchInternalUsers(inputValue).then(options => {
            callback(options);
        });
    };

    // --- Tooltip Render Function ---
    const renderTooltip = (props, text) => (
        <Tooltip id={`tooltip-${text.toLowerCase().replace(/\s+/g, '-')}`} {...props}>
            {text}
        </Tooltip>
    );

    // --- Input Validation Styling (Example) ---
    const getValidationClass = (isValid) => {
        if (!submitClicked) return '';
        return isValid ? 'is-valid' : 'is-invalid';
    };

    return (
        <div className='d-flex flex-column gap-2'>
            <Modal show={show} onHide={onHide} size="lg" backdrop="static" keyboard={false} className="custom-modal-bg share-report-modal">
                <Modal.Header closeButton>
                    <Modal.Title className="fs-12">
                        Share Report - <span className="share-report-filename" style={{ whiteSpace: 'pre-line', wordBreak: 'break-all' }}>{reportName}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            {/* Removed form tag as we manage state directly */}
                            <div className="row">
                                {/* --- QR Code --- */}
                                {isLoadingQr && <div className="col-12 text-center mb-1"><p>Loading...</p></div>}
                                {qrCodeUrl && !isLoadingQr && (
                                    <div className="col-12 text-center mb-1">
                                        <div className="img-fluid">
                                            {/* Added error handling for image */}
                                            <img
                                                src={qrCodeUrl}
                                                alt="Scan QR Code"
                                                height="350"
                                                onError={(e) => { e.target.style.display = 'none'; console.error("QR Image failed to load"); }}
                                            />
                                        </div>
                                        <div className="text-center fw-bold mt-4 text-dark" style={{ fontSize: '2rem', color: '#ff9f43' }}>
                                            Scan QR Code
                                            <hr />
                                        </div>
                                    </div>
                                )}

                                {/* --- Share Icons --- */}
                                <div className="col-12 text-center mb-3 d-flex justify-content-center "> {/* Improved spacing */}
                                    <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Copy Link to Clipboard')}>
                                        <span onClick={handleCopyLink} style={{ cursor: 'pointer' }}>
                                            <FaClipboard size="1.75em" className="text-primary mx-3" />
                                        </span>
                                    </OverlayTrigger>

                                    <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Share to Internal Users')}>
                                        <span onClick={() => handleMethodSelect('pmr')} style={{ cursor: 'pointer' }}>
                                            <FaUser size="1.75em" className='text-warning mx-3' color='#ff9f43' /> {/* Highlight active */}
                                        </span>
                                    </OverlayTrigger>

                                    <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Share via Email')}>
                                        <span onClick={() => handleMethodSelect('email')} style={{ cursor: 'pointer' }}>
                                            <FaEnvelope size="1.75em" className='text-info mx-3' />
                                        </span>
                                    </OverlayTrigger>

                                    <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Share via SMS')}>
                                        <span onClick={() => setShowComingSoonModal(true)}>
                                            <FaTelegramPlane size="1.75em" className='text-danger mx-3' />
                                        </span>
                                    </OverlayTrigger>

                                    <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Share via Whatsapp')}>
                                        <span onClick={() => setShowComingSoonModal(true)}>
                                            <FaWhatsapp size="1.75em" className="text-success mx-3" />
                                        </span>
                                    </OverlayTrigger>
                                </div>

                                {/* --- Conditional Inputs --- */}
                                {shareMethod === 'email' && (
                                    <div className="col-12 col-sm-12 my-1" style={{ padding: 0 }}>
                                        <div style={{ display: 'flex', alignItems: 'stretch' }}>
                                            <FormControl
                                                type="email"
                                                placeholder="Add email address to share report via Email"
                                                value={emailAddress}
                                                onChange={(e) => setEmailAddress(e.target.value)}
                                                required
                                                className={getValidationClass(/\S+@\S+\.\S+/.test(emailAddress))}
                                                style={{
                                                    borderTopRightRadius: 0,
                                                    borderBottomRightRadius: 0,
                                                    minHeight: '38px',
                                                    fontSize: '1rem'
                                                }}
                                            />
                                            <Button
                                                variant="outline-primary"
                                                onClick={handleShare}
                                                style={{
                                                    borderTopLeftRadius: 0,
                                                    borderBottomLeftRadius: 0,
                                                    minHeight: '38px',
                                                    height: '100%',
                                                    marginLeft: '-1px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '48px',
                                                    padding: 0
                                                }}
                                            >
                                                <FaEnvelope color="var(--pmr-primary)" />
                                            </Button>
                                        </div>
                                        {submitClicked && !/\S+@\S+\.\S+/.test(emailAddress) && (
                                            <div className="invalid-feedback d-block">Please enter a valid email.</div>
                                        )}
                                    </div>
                                )}

                                {(shareMethod === 'sms' || shareMethod === 'whatsapp') && (
                                    <div className="col-12 col-sm-12 my-1">
                                        <InputGroup>
                                            <FormControl
                                                type="tel"
                                                placeholder={`Add phone number to share link via ${shareMethod === 'sms' ? 'SMS' : 'Whatsapp'}`}
                                                value={phoneNumber}
                                                onChange={(e) => setPhoneNumber(e.target.value)}
                                                required
                                                className={getValidationClass(/^[+]?[1-9]\d{10,15}$/.test(phoneNumber))}
                                                style={{
                                                    borderTopRightRadius: 0,
                                                    borderBottomRightRadius: 0,
                                                    minHeight: '38px',
                                                    fontSize: '1rem'
                                                }}
                                            />
                                            <Button
                                                variant="outline-primary"
                                                onClick={handleShare}
                                                style={{
                                                    borderTopLeftRadius: 0,
                                                    borderBottomLeftRadius: 0,
                                                    minHeight: '38px',
                                                    height: '38px',
                                                    marginLeft: '-1px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '48px',
                                                    padding: 0
                                                }}
                                            >
                                                {shareMethod === 'sms'
                                                    ? <FaTelegramPlane color="#00AEEF" />
                                                    : <FaWhatsapp color="#25D366" />}
                                            </Button>
                                        </InputGroup>
                                        {submitClicked && !/^[+]?[1-9]\d{10,15}$/.test(phoneNumber) && <div className="invalid-feedback d-block">Please enter a valid phone number.</div>}
                                    </div>
                                )}

                                {shareMethod === 'pmr' && (
                                    <div className="col-12 px-0">
                                        {/* Internal User Select (using react-select async example) */}
                                        <div className="col-12 mb-2">
                                            <Form.Group controlId="internalUserSelect">
                                                <Form.Label className='fw-bold' style={{
                                                    color: 'var(--pmr-text-heading)',
                                                    fontSize: '0.857rem'
                                                }}>Select Internal User</Form.Label>

                                                <div style={{ position: 'relative', width: '100%' }}>
                                                    <Select
                                                        classNamePrefix="pmr-select"
                                                        options={internalUsersOptions}
                                                        name="internalUserSelect"
                                                        value={internalUser}
                                                        onChange={(selectedOption) => {
                                                            setInternalUser(selectedOption);
                                                            setSearchInput(selectedOption ? selectedOption.label : '');
                                                            console.log('Selected internal user:', selectedOption); // <-- This will print the selected value

                                                        }}
                                                        onInputChange={(inputValue) => {
                                                            setSearchInput(inputValue);
                                                            if (inputValue && inputValue.length >= 3) {
                                                                setTimeout(() => {
                                                                    fetchInternalUsers(inputValue);
                                                                }, 300);
                                                            } else {
                                                                setInternalUsersOptions([]);
                                                            }
                                                        }}
                                                        styles={{
                                                            ...customStyles,
                                                            placeholder: (provided) => ({
                                                                ...provided,
                                                                color: 'var(--pmr-text-muted)',
                                                                fontSize: '12px'
                                                            })
                                                        }}
                                                        menuPlacement="top"
                                                        menuPortalTarget={document.body}
                                                        menuIsOpen={searchInput.length >= 3 ? undefined : false}
                                                        placeholder="Type at least 3 characters to search for an internal user..."
                                                        isInvalid={submitClicked && !internalUser}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        isLoading={isLoadingUsers}
                                                        components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                                        noOptionsMessage={() => "No users found"}
                                                        formatOptionLabel={(option) => (
                                                            <div>
                                                                <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                                                                    {option.label.split('[')[0].trim()}
                                                                </span>
                                                                <span className="ms-2" style={{ color: 'var(--pmr-text-muted)', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '12px' }}>
                                                                    [{option.value}]
                                                                </span>
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                                {submitClicked && !internalUser && <div className="invalid-feedback d-block">Please select a user</div>}
                                            </Form.Group>
                                        </div>

                                        {/* Notes Textarea */}
                                        <div className="input-group col-12 mb-2">
                                            <FormControl
                                                as="textarea"
                                                id="notes"
                                                placeholder="Notes (Optional)"
                                                value={notes}
                                                onChange={(e) => setNotes(e.target.value)}
                                                rows={2}
                                            />
                                        </div>

                                        {/* Validity Select */}
                                        <div className="input-group col-12 mb-1" style={{ display: 'flex', alignItems: 'stretch', padding: 0 }}>
                                            <div style={{ flex: 1 }}>
                                                <Select
                                                    placeholder="Valid Upto"
                                                    options={validityOptions}
                                                    value={validity}
                                                    onChange={setValidity}
                                                    className={`share-report-validity-select text-left flex-grow-1${submitClicked && !validity ? ' is-invalid' : ''}`}
                                                    classNamePrefix="pmr-select"
                                                    isInvalid={submitClicked && !validity}
                                                    styles={{
                                                        ...customStyles,
                                                        control: (provided, state) => {
                                                            const isInvalid = state.selectProps.isInvalid;
                                                            const borderColor = isInvalid
                                                                ? 'var(--pmr-danger)'
                                                                : 'var(--pmr-border-input)';
                                                            return {
                                                                ...provided,
                                                                borderTopRightRadius: 0,
                                                                borderBottomRightRadius: 0,
                                                                minHeight: '38px',
                                                                height: '100%',
                                                                borderColor,
                                                                boxShadow: 'none',
                                                                '&:hover': {
                                                                    borderColor,
                                                                },
                                                            };
                                                        },
                                                        menu: (provided) => ({
                                                            ...customStyles.menu(provided),
                                                            minWidth: '200px',
                                                        }),
                                                    }}
                                                />
                                            </div>
                                            <Button
                                                variant="outline-primary"
                                                className="share-report-share-btn"
                                                onClick={handleShare}
                                                style={{
                                                    borderTopLeftRadius: 0,
                                                    borderBottomLeftRadius: 0,
                                                    minHeight: '38px',
                                                    height: '100%',
                                                    marginLeft: '-1px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '0 24px',
                                                    fontWeight: 600,
                                                    fontSize: '1rem'
                                                }}
                                            >
                                                Share
                                            </Button>
                                            {submitClicked && !validity && (
                                                <div className="invalid-feedback d-block">Please select validity</div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                {/* Loading Overlay */}
                {isLoading && (
                    <div
                        style={{
                            position: "absolute",
                            left: "50%",
                            top: "50%",
                            transform: "translate(-50%, -50%)",
                            height: "100%",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            zIndex: 1000,
                            borderRadius: "8px"
                        }}
                    >
                        <LoadingSpinner />
                    </div>
                )}
            </Modal>

            <CustomSuccessModal show={showSuccessModal} onHide={() => { setShowSuccessModal(false); setMessage(''); onHide() }} message={message} />

            {showComingSoonModal && (
                <div className="custom-modal-overlay">
                    <div
                        className="custom-modal"
                        style={{ width: '480px', textAlign: 'center', padding: '32px 32px' }}
                    >
                        <div style={{ marginBottom: 24 }}>
                            <div
                                style={{
                                    width: 80,
                                    height: 80,
                                    borderRadius: '50%',
                                    border: '3px solid #f9c89b',
                                    margin: '0 auto',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <span style={{ fontSize: 48, color: '#f9c89b' }}>!</span>
                            </div>
                        </div>
                        <h4 style={{ fontWeight: 600, marginBottom: 12 }}>Coming Soon</h4>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
                            <button
                                className="btn btn-primary share-report-coming-soon-btn"
                                style={{
                                    minWidth: 100,
                                    fontWeight: 500
                                }}
                                onClick={() => setShowComingSoonModal(false)}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}


        </div>

    );
}

export default ShareReportModal;
